import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initProductTelemetry, trackAreaView, areaForPath } from "../../services/analyticsClient";

export default function ProductTelemetryProvider({ children }) {
  const location = useLocation();
  const lastArea = useRef("");

  useEffect(() => {
    const cleanup = initProductTelemetry();
    return cleanup;
  }, []);

  useEffect(() => {
    const area = areaForPath(location.pathname);
    if (!area || area === lastArea.current) return;
    lastArea.current = area;
    trackAreaView(area, { search: location.search });
  }, [location.pathname, location.search]);

  return children;
}
